export default "__VITE_ASSET__BkKAKPKx__"